// extracted by mini-css-extract-plugin
export default {"root":"_18FLte-dTcDOe5uPWf2_o3","page_container":"_2UQmTTDx66S6aVBbjZ3d3C"};